@if (showsContactItem) {
  @if (contactIds.length > 1) {
    <!-- Multiple Real contacts, opens in Dynamic Panel (View) -->
    <app-context-menu-item
      title="View contacts"
      (execute)="viewContacts(contactIds)"
    />
  } @else if (contactIds.length === 1) {
    <!-- Real single contact, opens in Dynamic Panel (Edit) -->
    <app-context-menu-item
      title="Open contact"
      (execute)="openContact(contactIds[0])"
    />
  } @else {
    <!-- Auto Generated Contact -->
    <app-context-menu-item
      title="Add to contacts"
      [disabled]="!contactsLoaded || !ownAddressLoaded"
      (execute)="addToContacts(participant)"
    />
  }
}
@if (!isOwnAddress) {
  <app-context-menu-item
    [title]="isSenderVip ? 'Remove from VIPs' : 'Add to VIPs'"
    (execute)="toggleVip()"
  />

  <app-context-menu-item
    [title]="isBlackListed ? 'Remove from Black List' : 'Add to Black List'"
    [disabled]="!blackListLoaded || blockListReadOnly"
    [note]="blockListReadOnly ? MAIL_SETTINGS_REFUSED_REASON : undefined"
    (execute)="moveToList('black-list')"
  />
}

@if (!isOwnAddress || showsContactItem) {
  <app-context-menu-divider />
}

<app-context-menu-item
  title="Copy email address"
  [close]="true"
  (execute)="copy()"
/>

<app-context-menu-item
  title="Compose email"
  [close]="true"
  (execute)="compose()"
/>
